import "./awards.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { SectionTitle } from "../../../../components/landing/ui/SectionTitle/SectionTitle";
import { Slider } from "../../../../components/landing/ui/Slider/Slider";

type AwardItem = {
  title?: string;
  image: string;
  file?: string;
};

export const Awards = () => {
  const data = useHomeContent();
  const sliderAria = data?.common?.sliderAria;
  const awardsBlock = data?.awards;
  const awards: AwardItem[] = Array.isArray(awardsBlock)
    ? awardsBlock
    : awardsBlock?.items ?? [];
  const title =
    (!Array.isArray(awardsBlock) && awardsBlock?.title) ??
    data?.awardsTitle ??
    "";

  const imageAltFallback =
    (!Array.isArray(awardsBlock) && awardsBlock?.imageAltFallback) || "award";

  if (!awards.length) return null;

  const openFile = (file?: string) => {
    if (!file) return;
    window.open(file, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="oc-awards oc-section">
      <div className="oc-container">
        <SectionTitle title={title} />

        <div className="oc-awards__desktop">
          <div className="oc-awards__grid">
            {awards.map((a, i) => {
              const clickable = Boolean(a.file);

              return (
                <div
                  key={i}
                  className={`oc-awards__item ${
                    clickable ? "oc-awards__item--click" : ""
                  }`}
                  role={clickable ? "button" : undefined}
                  tabIndex={clickable ? 0 : -1}
                  onClick={() => openFile(a.file)}
                  onKeyDown={(e) => {
                    if (!clickable) return;
                    if (e.key === "Enter" || e.key === " ") openFile(a.file);
                  }}
                >
                  <div className="oc-awards__imgCon">
                    <div className="oc-awards__imgWrap">
                      <img src={a.image} alt={a.title || imageAltFallback} />
                    </div>
                  </div>
                  <div className="oc-awards__cap">{a.title}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="oc-awards__mobile">
          <Slider
            items={awards}
            showArrows={false}
            showDots={true}
            loop
            swipe
            autoPlay={false}
            scrollBy={1}
            gap={12}
            breakpoint={{
              mobileMaxWidth: 768,
              slidesToShowMobile: 2,
              slidesToShowDesktop: 4,
            }}
            ariaLabels={sliderAria}
            renderItem={(a: AwardItem) => {
              const clickable = Boolean(a.file);

              return (
                <div
                  className={`oc-awards__item ${
                    clickable ? "oc-awards__item--click" : ""
                  }`}
                  role={clickable ? "button" : undefined}
                  tabIndex={clickable ? 0 : -1}
                  onClick={() => openFile(a.file)}
                  onKeyDown={(e) => {
                    if (!clickable) return;
                    if (e.key === "Enter" || e.key === " ") openFile(a.file);
                  }}
                >
                  <div className="oc-awards__imgCon">
                    <div className="oc-awards__imgWrap">
                      <img src={a.image} alt={a.title || imageAltFallback} />
                    </div>
                  </div>
                  <div className="oc-awards__cap">{a.title}</div>
                </div>
              );
            }}
          />
        </div>
      </div>
    </section>
  );
};
